import './autoform.css'

import React, { useEffect, useRef, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next';
import { authHeader, handleResponse } from '../../Helpers'

import { BigButton } from '../../Components'
import { Consent } from '../'
import { Element } from './Elements'
import EnglishResourceBundle from './locale/autoform.en.json'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import FrenchResourceBundle from './locale/autoform.fr.json'
import ReactDOM from "react-dom";
import {useHistory} from 'react-router-dom';

export const AutoForm = (props) => {
    const history = useHistory();
    
    const { t, i18n } = useTranslation();
    i18n.addResourceBundle('en', 'autoform', EnglishResourceBundle);
    i18n.addResourceBundle('fr', 'autoform', FrenchResourceBundle);

    let formElement = useRef(null);

    const [formChanged, setFormChanged] = useState(false);
    const [model, setModel] = useState(props.data.formModel || {});
    const [defaultModel] = useState(props.data.form.defaultModel || {});
    const [saving, setSaving] = useState(false);
    const [saved, setSaved] = useState(null);
    const [messages, setMessages] = useState([]);
    const [validated, setValidated] = useState(false);
    const [termsChecked, setTermsChecked] = useState(false);

    const onSave = (notify) => {
        setSaving(true);
        setSaved(null);

        notify = notify || false;

        context.validators.validate();

        const fileInputs = [...formElement.current.elements].filter(p => p.type === "file");
        const formData = new FormData();
        const route = !props.ea || props.ea.length === 0 ? `/savemodel` : `/q/${props.ea}/savemodel`;

        formData.append("id", props.data.form.id);
        formData.append("status", props.data.formVersion.status);
        formData.append("model", JSON.stringify(model));

        if (termsChecked) {
            formData.append("clientTermId", getLocalizeValue(props.data.clientTerms, i18n.language, "id"));
            formData.append("formTermId", getLocalizeValue(props.data.formTerms, i18n.language, "id"));
        }

        let allFileIndex = 0;
        fileInputs.forEach(fileInput => {
            let fileIndex = 0;
            [...fileInput.files].forEach(file => {
                formData.append("files", file);
                formData.append("paths", `${allFileIndex++};${fileInput.getAttribute("aform-path")}.value[${fileIndex++}]`);
            });
        });
        formData.append("notify", notify);

        const request = {
            method: "POST",
            headers: Object.assign({}, authHeader()),
            body: formData
        }

        fetch(`${process.env.REACT_APP_APIURL}/api/forms${route}?culture=${i18n.language.substring(0, 2)}`, request)
            .then(handleResponse)
            .then(json => {
                let saved = null;

                if (json.messages && json.messages.filter(m => m.messageType === 8).length === 0) {
                    fileInputs.forEach(element => element.value = "");

                    const atLeastOnError = hasErrors(model);
                    saved = {
                        hasErrors: atLeastOnError,
                        message: atLeastOnError ? t("autoform:savedWithErrors") : t("autoform:saved")
                    }

                    if (props.onSave)
                       props.onSave(json);

                    setFormChanged(false);
                    setValidated(!atLeastOnError);
                } else {
                    setValidated(false);
                }

                setSaved(saved);
                setMessages(json.messages);

                if (saved && saved.hasErrors)
                    scrollToFirstErrorOrTop();
            })
            .finally(() => {
                setSaving(false);

                if (notify)
                    history.push('/');
            });
    }

    const onSubmit = (e) => {
        e.preventDefault();
        onSave(true);
    }

    const readDefaultValue = (modelPath, alternativeDefaultValue) => {

        const deepRead = (branch, name) => {
            if (name.startsWith("[")) {
                if (Array.isArray(branch.value))
                    return branch.value[parseInt(name.slice(1, -1))];

                return branch;
            }

            if (!branch[name]) {
                return alternativeDefaultValue;
            }

            return branch[name];
        }

        modelPath = modelPath || "";
        const path = modelPath.split('.');
        let branch = { ...defaultModel };

        for (let i = 0, l = path.length; i < l; i++) {
            const pathItem = path[i];
            branch = deepRead(branch, pathItem);
        }

        return branch;
    }

    const context = {
        defaultModel: { ...defaultModel },
        download: function (fileId, filename) {
            const request = {
                method: "POST",
                headers: Object.assign({}, authHeader())
            }

            const route = !props.ea || props.ea.length === 0 ? `/${props.data.form.id}/download/${fileId}` :
                `/q/${props.ea}/download/${fileId}`;

            fetch(`${process.env.REACT_APP_APIURL}/api/forms${route}?culture=${i18n.language.substring(0, 2)}`, request)
                .then(response => {
                    if (!response.ok)
                        throw Error(response);

                    return response;
                })
                .then(response => {
                    return response.blob();
                })
                .then(blob => {
                    this.downloadBlob(blob, filename);
                })
                .catch(response => {
                    console.error("download error", response);
                });
        },
        downloadBlob: function (blob, filename) {
            const url = window.URL.createObjectURL(blob);
            let tempLink = document.createElement('a');
            tempLink.href = url;
            tempLink.setAttribute('download', filename);
            tempLink.click();
            URL.revokeObjectURL(url);
        },
        getModel: () => model,
        readModel: (modelPath, defaultValue) => {
            const deepRead = (branch, name) => {
                if (name.startsWith("[")) {
                    if (Array.isArray(branch.value))
                        return branch.value[parseInt(name.slice(1, -1))];

                    return branch;
                }

                if (!branch[name]) {
                    const presetDefaultValue = Array.isArray(defaultValue) ? defaultValue : readDefaultValue(modelPath, defaultValue);
                    branch[name] = { "value": presetDefaultValue, "errors": [] };
                }

                return branch[name];
            }

            modelPath = modelPath || "";
            let branch = model;
            const path = modelPath.split('.');

            for (let i = 0, l = path.length; i < l; i++) {
                const pathItem = path[i];
                branch = deepRead(branch, pathItem);
            }

            return branch;
        },
        isReadOnly: props.data.isReadOnly,
        updateModel: (modelPath, value, errors) => {
            const newModel = { ...model };
            const modelString = JSON.stringify(model);

            const deepUpdate = (branch, name) => {
                if (name.startsWith("[")) {
                    if (!branch.value)
                        branch.value = { "value": [], "errors": [] };

                    const index = parseInt(name.slice(1, -1));
                    return branch.value[index];
                }

                if (!branch[name]) {
                    branch[name] = { "value": "", "errors": [] };
                }

                return branch[name];
            }

            modelPath = modelPath || "";
            const path = modelPath.split('.');
            let branch = newModel;

            for (let i = 0, l = path.length; i < l; i++) {
                const pathItem = path[i];
                branch = deepUpdate(branch, pathItem);
            }

            branch.value = value;
            branch.errors = errors || [];

            const changed = formChanged || JSON.stringify(newModel) !== modelString

            setModel(newModel);
            setFormChanged(changed);
            setValidated(!changed);
        },
        validators: {
            observers: [],
            subscribe: f => context.validators.observers.push(f),
            unsubscribe: f => context.validators.observers.filter(subscriber => subscriber !== f),
            validate: () => {
                context.validators.observers.forEach(observer => observer());
            }
        },
        validateElement: function (e, element, value) {
            const messages = [];

            if (e && e.checkValidity && !e.checkValidity()) {
                if (e.validity.valueMissing) {
                    messages.push({ name: "valueMissing", type: e.type });
                }
                else if (e.validity.typeMismatch) {
                    messages.push({ name: "typeMismatch", type: e.type, value: e.value });
                }
                else if (e.validity.patternMismatch) {
                    messages.push({ name: "patternMismatch", type: e.type, pattern: e.pattern, value: e.value });
                }
                else if (e.validity.tooLong) {
                    messages.push({ name: "tooLong", type: e.type, maxLength: e.maxLength, value: e.value, length: e.value.length });
                }
                else if (e.validity.tooShort) {
                    messages.push({ name: "tooShort", type: e.type, minLength: e.minLength, value: e.value, length: e.value.length });
                }
                else if (e.validity.rangeUnderflow) {
                    messages.push({ name: "rangeUnderflow", type: e.type, min: e.min, value: e.value });
                }
                else if (e.validity.rangeOverflow) {
                    messages.push({ name: "rangeOverflow", type: e.type, max: e.max, value: e.value });
                }
                else if (e.validity.stepMismatch) {
                    messages.push({ name: "stepMismatch", type: e.type, step: e.step, value: e.value });
                }
                else if (e.validity.badInput) {
                    messages.push({ name: "badInput", type: e.type });
                }
            }

            element.validations && element.validations.forEach(validation => {
                if (validation.email && validation.phone && value && value.length > 0) {
                    if (!new RegExp(/^(([^<>()[\],;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$|^[+]{0,1}[1]{0,1}[ ]{0,1}[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/).test(value))
                        messages.push({ name: "invalidEmailorPhone" });
                } else if (validation.email && value && value.length > 0) {
                    if (!new RegExp(/^(([^<>()[\],;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i).test(value))
                        messages.push({ name: "invalidEmail" });
                } else if (validation.phone && value && value.length > 0) {
                    if (!new RegExp(/^[+]{0,1}[1]{0,1}[ ]{0,1}[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/).test(value))
                        messages.push({ name: "invalidPhone" });
                }

                if (validation.regex && validation.text && validation.name && !new RegExp(validation.regex).test(value)) {
                    messages.push({ name: validation.name, regex: validation.regex });
                }
            })

            return messages;
        }
    }

    const scrollToFirstErrorOrTop = () => {
        const node = ReactDOM.findDOMNode(formElement.current);
        const firstInvalidElement = node && node.querySelector('.is-invalid');

        const getOffsetTop = element => {
            let offsetTop = 0;
            while (element) {
                offsetTop += element.offsetTop;
                element = element.offsetParent;
            }
            return offsetTop;
        }

        let top = firstInvalidElement ? getOffsetTop(firstInvalidElement) : 0;
        window.scrollTo({ top: top, behavior: 'smooth' });
    }

    const hasErrors = obj => {
        if (obj == null)
            return false;

        let atleastOnError = false;
        for (let [key, value] of Object.entries(obj)) {
            if (key === "errors" && Array.isArray(value) && value.length > 0) {
                atleastOnError = true;
            }
            else if (typeof value === "object") {
                atleastOnError = hasErrors(value);
            }

            if (atleastOnError)
                break;
        }

        return atleastOnError;
    }

    const getLocalizeValue = (obj, culture, name) => {
        let localizeObj = obj && obj[culture.substring(0, 2)] ? obj[culture.substring(0, 2)] : null;

        if (localizeObj == null) {
            const keys = Object.keys(obj);
            if (keys.length > 0)
                localizeObj = obj[keys[0]];
        }

        if (localizeObj == null)
            return "";

        return localizeObj[name] ? localizeObj[name] : "";
    }

    useEffect(() => {
        const onUnload = (event) => {
            if (!formChanged)
                return;

            event.returnValue = t("autoform:beforeUnload");
        }

        window.addEventListener("beforeunload", onUnload);

        return function cleanUp() {
            window.removeEventListener("beforeunload", onUnload);
        }
    }, [formChanged, t, context]);

    return (
        <>
            {context.isReadOnly &&
                <div className="row mb-0">
                    <div className="col">
                        <div className="mb-0 alert alert-info" role="alert">
                            <Trans i18nKey="autoform:infoReadOnly"></Trans>
                        </div>
                    </div>
                </div>
            }

            <form lang={i18n.language.substring(0, 2)} noValidate onSubmit={onSubmit} ref={formElement}>
                {props.data.template.content && props.data.template.content.form && props.data.template.content.form.map((element, elementIndex) => <Element key={elementIndex} context={context} element={element}></Element>)}

                {hasErrors(model) &&
                    <>
                        <br className="mb-4"></br>

                        <div className="alert alert-warning" role="alert">
                            <div className="row">
                                <div className="col-11"><Trans i18nKey="autoform:warningCantNotify"></Trans></div>
                                <div className="col-1 text-right m-auto">
                                    <button type="button" className="btn btn-warning" onClick={scrollToFirstErrorOrTop}><FontAwesomeIcon icon="chevron-up" /></button>
                                </div>
                            </div>
                        </div>
                    </>
                }

                {messages && messages.length > 0 &&
                    <>
                        <br className="mb-4"></br>

                        <div className="alert alert-danger">
                            <ul className="list-unstyled mb-0">
                                {messages.map((m, mindex) => <li key={`${mindex}-${m.text}`}>{m.text}</li>)}
                            </ul>
                        </div>
                    </>
                }

                <Consent data={props.data} clientKey={props.clientKey} context={context} formKey={props.formKey} termsChanged={setTermsChecked} disabled={context.isReadOnly} />

                {!context.isReadOnly &&
                    <div className="no-print">
                        <hr></hr>
                        <BigButton
                            step="1"
                            text={t("autoform:step1Text")}
                            verb={t("autoform:step1Verb")}
                            icon={validated && termsChecked && saved && !formChanged && !hasErrors(model) ? "check" : "save"}
                            iconClassName={validated && termsChecked && saved && !formChanged && !hasErrors(model) ? "green" : ""}
                            active={!validated || !termsChecked}
                            disabled={saving}
                            processing={saving}
                            onClick={() => onSave(false)}
                        />
                        <BigButton
                            step="2"
                            disabledText={t("autoform:step2DisabledText")}
                            text={`${t("autoform:step2Text")} ${getLocalizeValue(props.data.clientLocalizations, i18n.language, "name")}.`}
                            verb={t("autoform:step2Verb")}
                            icon="share"
                            active={validated && termsChecked && !saving && !hasErrors(model)}
                            disabled={!validated || !termsChecked || saving || hasErrors(model)}
                            onClick={() => onSave(true)}
                        />
                    </div>
                }


                <div className="row flex-nowrap justify-content-between align-items-center no-print">
                    <div className="col d-flex justify-content-end align-items-center pt-0 pb-0">
                        <button onClick={() => window.print()} type="button" className="btn btn-sm btn-link-footer"><Trans i18nKey="autoform:print"></Trans></button>
                    </div>
                </div>
            </form>
        </>
    )
}